import { useState } from "react"
import Grid from "@mui/material/Grid"
import {ThumbDown} from "@mui/icons-material"
import {useTranslation} from "react-i18next"
import { useSnackbar } from "notistack"

import {CompanyType} from "../../../../../../types/company"
// @ts-ignore
import Button from "../../../../../../components/Button"
// @ts-ignore
import Dialog from "../../../../../../components/Dialog"
import { BulletinActionCode  } from "../../../../../../types/action"
import ConfirmOrCancelPrompt from "../../../../../../components/ConfirmOrCancelPrompt"
import {noLongerNeeded} from "../../../../../../api/bulletin"
import { ProjectUserRoleCode } from "../../../../../../types/userRoles"
import {bulletinActionIdForNotNeeded} from '../../../../../../types/bulletin'


function showThisButton(
  companyType: CompanyType,
  projectUserRole: ProjectUserRoleCode,
  bulltetinActionCode: BulletinActionCode
): boolean {
  // must be gc
  if (companyType !== 'cm') return false
  // must be a pm or super
  if (!["pm", "super"].includes(projectUserRole)) return false
  // these statuses can always send
  const showForStatuses: BulletinActionCode[] = ['draft', 'review', 'estimates_approved']
  return showForStatuses.includes(bulltetinActionCode)
}

interface SendRfpToSubsProps {
  companyType: CompanyType,
  projectUserRole: ProjectUserRoleCode,
  bulletinActionCode: BulletinActionCode,
  bulletinId: string,
  projectId: string,
  bulletinActionChange: (new_action_id: number) => void,
  togglePocketForm: () => void
}

export function NoLongerNeeded(
  {companyType, projectUserRole, bulletinActionCode, bulletinId, projectId, bulletinActionChange, togglePocketForm}: SendRfpToSubsProps
): JSX.Element {
  const { t } = useTranslation("private")
  const [confirmOrCancelPromptOpen, setConfirmOrCancelPromptOpen] = useState<boolean>(false)
  const { enqueueSnackbar } = useSnackbar()

  const openConfirmCancelDialog = async (): Promise<void> => {
    togglePocketForm()
    setConfirmOrCancelPromptOpen(true)
  }

  const closeConfirmCancelDialog = () => {
    setConfirmOrCancelPromptOpen(false)
  }

  const submitForm = async (): Promise<void> => {
    closeConfirmCancelDialog()
    try {
      const {data} = await noLongerNeeded(projectId, bulletinId)
      if(data.success){
        // Changes bulletin status
        bulletinActionChange(bulletinActionIdForNotNeeded)
        enqueueSnackbar(t('view.Bulletins.SingleBulletin.NoLongerNeeded.apiSuccess'), {variant: "success"})
      } else {
        enqueueSnackbar(t('view.Bulletins.SingleBulletin.NoLongerNeeded.apiFail'), {variant: "error"})
      }
    } catch (_) {
      enqueueSnackbar(t('view.Bulletins.SingleBulletin.NoLongerNeeded.apiFail'), {variant: "error"})
    }
  }

  return showThisButton(companyType, projectUserRole, bulletinActionCode) ? (
    <>
      <Grid item>
        <Button
          color="error"
          endIcon={<ThumbDown />}
          style={{ minWidth: 125 }}
          onClick={openConfirmCancelDialog}
        >
          {t("view.Bulletins.SingleBulletin.NoLongerNeeded.button")}
        </Button>
      </Grid>

      <Dialog
        open={confirmOrCancelPromptOpen}
        onClose={closeConfirmCancelDialog}
        maxWidth={'sm'}
      >
        <ConfirmOrCancelPrompt
          submitForm={submitForm}
          closeDialog={closeConfirmCancelDialog}
          dialogPrompt={t("view.Bulletins.SingleBulletin.NoLongerNeeded.dialogPrompt")}
        />
      </Dialog>
    </>
  ) : (
    <></>
  )
}
